angular.module('ikeweb.spike.step').controller('BreadcrumbController', ['STEPS', 'stepService',
    function(STEPS, stepService) {
        this.STEPS = STEPS;

        this.changeStep = this.changeStep || stepService.changeStep;

        this.activeIfStepIs = function(step) {
            return stepService.isCurrentStep(step) ? 'active' : '';
        };

        this.isAlignmentDone = function() {
            return this.capture && this.capture.isAlignmentDone();
        };

        this.isTransitionForbidden = stepService.isTransitionForbidden;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/step/breadcrumb/breadcrumb.controller.js
// module id = 597
// module chunks = 0